import React, { useEffect, useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

const Rejected = () => {
  const [rejectedClaims, setRejectedClaims] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'claims'), where('status', '==', 'rejected'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const filtered = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setRejectedClaims(filtered);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <h2>❌ Rejected Claims</h2>
      {rejectedClaims.length === 0 ? (
        <p>No rejected claims found.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {rejectedClaims.map(claim => (
            <li key={claim.id} style={{
              backgroundColor: '#ffe3e3',
              padding: '1rem',
              marginBottom: '1rem',
              borderRadius: '10px'
            }}>
              <h4>{claim.itemName}</h4>
              <p><strong>Claimed by:</strong> {claim.claimedByName || claim.yourName}</p>
              <p><strong>Email:</strong> {claim.studentEmail}</p>
              <p><strong>Description:</strong> {claim.claimedDescription || claim.itemDescription}</p>
              <p><strong>Status:</strong> ❌ Rejected</p>
              <button
                onClick={() => alert(`🚫 Notification: Claim by ${claim.claimedByName || claim.yourName} was rejected.`)}
                style={{
                  marginTop: '0.5rem',
                  backgroundColor: '#B00020',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                Notify Rejection
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Rejected;
